import { Button } from "@/components/ui/button";

export const AboutSection = () => {
  return (
    <section
      id="about"
      className="py-12 md:py-20 bg-background"
      style={{ minHeight: '200px', contentVisibility: 'auto', containIntrinsicSize: '0 200px' }}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-3">
            Built by Esports. Trusted by the Best.
          </h2>
          <p className="text-muted-foreground leading-relaxed mb-4">
            Founded in 2022 by a team shaping competitive gaming since 2001 — including work with Fnatic, Natus Vincere, and EPICENTER — Paragon is an 80-strong broadcast studio based in Almaty, Kazakhstan. We deliver live production, observer tooling, graphics, multilingual coverage, and full-scale event solutions at the highest level.
          </p>
          <Button size="sm" asChild>
            <a href="mailto:info@paragonevents.gg">Request a Quote</a>
          </Button>
        </div>
      </div>
    </section>
  );
};
